// extracted by mini-css-extract-plugin
export default {"form-item":"EmailDrawerForm_form-item__CE2EC","empty-state-description":"EmailDrawerForm_empty-state-description__Pm4dZ","title":"EmailDrawerForm_title__AF3aK"};